import actions from '../../lib/api/actions';

export async function initDeviceId({ commit }) {
  commit('initDeviceId');
}

export async function initAccount({ commit }) {
  commit('initAccount');
}

export async function authenticateUser({ commit, dispatch }, payload) {
  const response = await actions.authenticateUser(payload);

  if (response.status === 200) {
    commit('updateUser', response.data.data);
    commit('updateLoggedIn', true);
    dispatch('setUserAccessToken', response.data.data.access_token);
    dispatch('saveUserPushToken');
    dispatch('shift/fetchShifts', null, { root: true });
  }
}

export function setUserAccessToken({ commit }, accessToken) {
  if (accessToken) {
    commit('updateAccessToken', accessToken);
  }
}

export async function logOut({ commit }) {
  commit('logOut');
}

export function updatePushToken({ commit }, payload) {
  commit('updatePushToken', payload);
}

export function saveUserPushToken({ state }) {
  if (state.isLoggedIn && state.pushToken) {
    actions.saveUserPushToken(state.account.id, state.pushToken);
  }
}

export async function fetchUsersMessages({ commit }) {
  const response = await actions.fetchUsersMessages();
  if (response.status === 200) {
    if (response.data.status === 'success') {
      commit('updateUsersMessages', response.data.data.messages.reverse());
    }
  }
}

export async function setEmployeeUnavailable({ commit }, payload) {
  const response = await actions.setEmployeeUnavailable(payload);

  if (response.status === 200) {
    commit('updateUser', response.data.data);
  }
}
